import React, { Component } from 'react';

import Loader from '../loader';

export default class TimetableLoader extends Component {
  state = {
    loaded: false,
    Timetable: null,
    error: false,
  };

  componentDidMount() {
    import(/* webpackChunkName: "timetable-component" */ /* webpackMode: "lazy" */ './weekly_prog')
      .then(({ default: Timetable }) => {
        this.setState({ Timetable, loaded: true });
      })
      .catch(e => {
        this.setState({ error: true, loaded: true });
      });
  }

  render() {
    const { loaded, Timetable, error } = this.state;
    if (!loaded) {
      return (
        <div className="loader">
          <Loader fill="#999" />
          <p className="center loader__text">Loading</p>
        </div>
      );
    }

    if (error) {
      return (
        <p className="center epsilon">
          We are sorry, there seems to be an issue loading the timetable. If the issues persists please
          <a href="/contactus"> contact us</a>
        </p>
      );
    }

    return <Timetable {...this.props} />;
  }
}
